<div class="item-passenger">
  <span *ngIf="passengerNew?.benefits?.tier"
    class="passenger-benefit passenger-benefit--{{classTier}}">
    {{ passengerNew?.benefits?.tier }}
  </span>
  <!-- Mostrar nombre del pasajero SIN infante -->
  <div class="passenger-name-container" *ngIf="!hasInfant">
    <p class="passenger-name mb-0">{{ passengerNew?.firstName }}</p>
    <span class="passenger-name">{{ passengerNew?.lastName }}</span>
  </div>

  <!-- Mostrar nombre del pasajero CON infante -->
  <div class="passenger-name-container" *ngIf="hasInfant">
    <p class="passenger-name">{{ passengerNew?.displayName }}</p>
    <span class="passenger-name d-flex gap-2">
      <img class="infant-icon" src="./assets/images/bags/infant.svg" alt="Infant Passenger">
      <span>+ {{ infant?.firstName }} {{ infant?.lastName }}</span>
    </span>
  </div>

  <span class="passenger-amount">{{ cost | amCurrency }} </span>
</div>